import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
 // getCampaignsSteps,
  SendMessages,
  UpdatefName,
  UpdateCompany,
  UpdatePosition,
  UpdateSurname,
  UpdateCountry,
  UpdateState,
  UpdateGender
} from "../campaignQueries";
import "./ContactDetails.css";
import photo from "../../assets/photo.png";
import { fetchMethod } from "../../../FetchMethod";
import "./CampaignTempListDetails.css";
import swal from "sweetalert";
import EditName from "../../LinkedinForm/EditName";
import EditCompany from "../../LinkedinForm/EditCompany";
import EditSurname from "../../LinkedinForm/EditSurname";
import EditGender from "../../LinkedinForm/EditGender";
import EditPosition from "../../LinkedinForm/EditPosition";
import EditCountry from "../../LinkedinForm/EditCountry";
import EditState from "../../LinkedinForm/EditState";
class CampaignTempListDetails extends Component {
  constructor(props) {
    
    super();
    this.state = {
      id: null,
      messageText: null,
      setOpen: false,
      fName: "",
      validationAlert: ""
    };
  }
  componentDidMount() {
   
  }

  formatDate = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      return (date = dd + "/" + mm + "/" + yyyy);
    }
  };

  RecieveddateFomate = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      let time1 = date.getTime();
      let time2 = date.getTimezoneOffset() * 60000;
      date = time1 + time2;
      date = new Date(date);

      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();

      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      let time = hours + ":" + minutes + " " + am_pm;

      return (date = time);
    }
  };

  formatDate1 = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;

      return (date = time);
    }
  };
  ConnectedOnformatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  handleSubmit = event => {
    event.preventDefault();
    this.SendMessage();
  };
  OnSubmit = event => {
    return event.key === "Enter" ? this.SendMessage() : "";
  };
  handleOpen = () => {
    this.setState({ setOpen: true }, () => {});
  };
  handleClose = () => {
    this.setState({ setOpen: false });
  };
  handleChange = e => {
    this.setState({ fName: e.target.value });
  };
  handleUpdatefName = () => {
    if (!this.state.fName) {
      return;
    }
    let test = {
      where: {
        id: this.props.details.id
      },
      data: {
        fname: this.state.fName
      }
    };

    fetchMethod(UpdatefName, test)
      .then(response => {
        return response.json();
      })
      .then(res => {
        if (res.data.TempcontactsdetailsUpsertWithWhere.fname) {
          this.props.refreshMessage(this.props.details.id);
          swal("Name  Updated Successfully", { icon: "success" });
          this.handleClose();
          this.props.onSearchClick();
        } else {
          swal("Name  Update Unsuccessfully ", { icon: "warning" });
        }
      })
      .catch(e => console.log(e));
  };

  SendMessage = () => {
    let test =
      this.state.messageText.trim().length > 0
        ? {
            data: {
              type: "SENT",
              contactid: this.props.details.id,
              message: this.state.messageText
            }
          }
        : "";

    fetchMethod(SendMessages, test)
      .then(response => {
        return response.json();
      })
      .then(res => {
        this.setState({ messageText: "" }, () => {
          this.props.refreshMessage(this.props.details.id);
        });

        if (res.data.ContactmessagesCreate.id) {
        }
      })
      .catch(e => console.log(e));
  };

  render() {
        
    let details = this.props.details;

    // let customer = this.props.Customer;
    // let workflowStep = this.props.ContactDetailsWorkflow;
    let ContactDetailsMessages = this.props.ContactDetailsMessages;

    let Name = details !== undefined ? details.name : "";
    let fName = details !== undefined ? details.fname : "";
    // let organization = details !== undefined ? details.organization : "";
    // let designation = details !== undefined ? details.designation : "";
    let surname = details !== undefined ? details.surname : "";
    let gender = details !== undefined ? details.gender : "";
    let image =
      details !== undefined &&
      details.profileimage !== undefined &&
      details.profileimage !== null
        ? details.profileimage.substr(0, 5)
        : "";

    return (
      <div className="DetailsContact">
        <div className="Details">
          <div className="Close">
            <h2 style={{ color: "#346beb" }}>{this.props.heading}</h2>
            <div>
              <CloseIcon
                onClick={this.props.Close}
                style={{ cursor: "pointer" }}
                fontSize="small"
              />
            </div>
          </div>
          <div className="Photo">
            <div className="Image">
              {image === "https" ? (
                <img
                  src={details.profileimage}
                  style={{
                    width: "88px",
                    height: "88px",
                    border: "double",
                    borderColor: "gray"
                  }}
                />
              ) : (
                <img
                  src={photo}
                  style={{
                    width: "88px",
                    height: "88px",
                    border: "double",
                    borderColor: "gray"
                  }}
                />
              )}
            </div>
            <div>
              <h2 style={{ color: "#346beb" }}>{Name}</h2>

              <div className="Headline">
                <ul>
                  <li className=" FirstName">
                    <span>Gender </span>
                    <span>:</span>
                    <span>{details !== undefined ? gender : ""}</span>
                    <span className="EditIcon">
                      <EditGender
                        editableData={this.props.details}
                        query={UpdateGender}
                        updateData={() => {
                          this.props.onSearchClick();

                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"editGender"}
                      />
                    </span>
                  </li>
                  <li className=" FirstName">
                    <span>First Name </span>
                    <span>:</span>
                    <span>{details !== undefined ? fName : ""}</span>
                    <span className="EditIcon">
                      <EditName
                        editableData={this.props.details}
                        query={UpdatefName}
                        updateData={() => {
                          this.props.onSearchClick();
                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"editFName"}
                      />
                    </span>
                  </li>
                  <li className=" FirstName">
                    <span>Surname </span>
                    <span>:</span>
                    <span>{details !== undefined ? surname : ""}</span>
                    <span className="EditIcon">
                      <EditSurname
                        editableData={this.props.details}
                        query={UpdateSurname}
                        updateData={() => {
                          this.props.onSearchClick();
                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"EditSurname"}
                      />
                    </span>
                  </li>
              
                 
                  <li>
                    <span>Phone</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.phonenumber : ""}
                    </span>
                  </li>
                  <li>
                    <span>Email</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.email : ""}</span>
                  </li>
                  <li>
                    <span>D.O.B</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.dateofbirth : ""}
                    </span>
                  </li>
                  <li>
                    <span>Connected On</span>
                    <span>:</span>
                    <span>
                      {details !== undefined
                        ? this.ConnectedOnformatDate(details.connectedon)
                        : ""}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ContactSection">
            <div className="ContactAddress">
              <p>Address</p>
              <div className="">
                <ul>
                  <li>
                    <span>Location</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.location : ""}</span>
                  </li>
                  <li>
                    <span>State</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.state : ""}
                      <span className="EditIcon">
                        <EditState
                          editableData={this.props.details}
                          query={UpdateState}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditState"}
                        />
                      </span>
                    </span>
                  </li>

                  <li>
                    <span>Country</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.country : ""}
                      <span className="EditIcon">
                        <EditCountry
                          editableData={this.props.details}
                          query={UpdateCountry}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditCountry"}
                        />
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="SocialContacts">
              <p>Social Contacts</p>
              <div className="">
                <ul>
                  <li>
                    <span>Twitter</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.twitter : ""}</span>
                  </li>

                  <li>
                    <span>Skype</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.skype : ""}</span>
                  </li>

                  <li>
                    <span>Followers</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.numberoffollowers : ""}
                    </span>
                  </li>

                  <li>
                    <span>LinkedIn</span>
                    <span>:</span>
                    <span>
                      <a
                        href={details !== undefined ? details.profileurl : ""}
                        title={details !== undefined ? details.profileurl : ""}
                        target="_blank"
                      >
                        {details !== undefined ? details.profileurl : ""}
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ProfessionalDetails">
              <p>Professional Details</p>
              <div className="">
                <ul>
                  <li>
                    <span>Current Position</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.designation : ""}
                      <span className="EditIcon">
                        <EditPosition
                          editableData={this.props.details}
                          query={UpdatePosition}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditPosition"}
                        />
                      </span>
                    </span>
                  </li>

                  <li>
                    <span>Current Company</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.organization : ""}
                      <span className="EditIcon">
                        <EditCompany
                          editableData={this.props.details}
                          query={UpdateCompany}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditCompany"}
                        />
                      </span>
                    </span>
                  </li>

                  <li>
                    <span>Industry</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.industry : ""}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="ContactDetailsMessages">
            <h3> Message Received </h3>
            {ContactDetailsMessages !== undefined &&
            ContactDetailsMessages !== null &&
            ContactDetailsMessages.length !== 0
              ? ContactDetailsMessages.map(message => {
                  if (
                    message.type === "SENT" &&
                    message.message !== "" &&
                    message.message !== null
                  ) {
                    return (
                      <React.Fragment>
                        <div className="SentMessages">
                          <span>{message.message}</span>
                        </div>
                        <div className="SentMessageData">
                          <span>
                            {message.messagedatetime
                              ? message.messagedatetime
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join("/")
                              : ""}
                          </span>
                          <span>
                            {this.formatDate1(message.messagedatetime)}
                          </span>
                        </div>
                      </React.Fragment>
                    );
                  } else if (
                    message.message !== "" &&
                    message.message !== null
                  ) {
                    return (
                      <React.Fragment>
                        <div className="ReceivedMessages">
                          <span>{message.message}</span>
                        </div>
                        <div className="ReceivedMessageData">
                          <span>
                            {message.messagedatetime
                              .split("T")[0]
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                          <span>
                            {this.RecieveddateFomate(message.messagedatetime)}
                          </span>
                        </div>
                      </React.Fragment>
                    );
                  }
                })
              : ""}
          </div>
        </div>
      </div>
    );
  }
}

export default CampaignTempListDetails;
